import memoize from 'transmute/memoize';
import { PlayerStatuses } from '../stores/AudioPlaybackStore';
export const getParsedPlayerStatuses = memoize(status => ({
  isLoaded: status !== PlayerStatuses.LOADING && status !== PlayerStatuses.ERROR,
  isPaused: [PlayerStatuses.PAUSED, PlayerStatuses.INITIAL, PlayerStatuses.LOADING, PlayerStatuses.ENDED, PlayerStatuses.ERROR].includes(status),
  isLoading: status === PlayerStatuses.LOADING,
  isError: status === PlayerStatuses.ERROR,
  isPlaying: status === PlayerStatuses.PLAYING
}));